import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import WARecordingSettingModal from '../components/pages/waiting-area/recording/content';

function WAAudioSettingPage(props) {
  const showWAAudioSettingModal = useSelector((state) => state.modalReducer.showWAAudioSettingModal);
  const isAdmin =
    useSelector((state) => state.usersReducer.userProfile) &&
    useSelector((state) => state.usersReducer.userProfile.isAdmin);
  const dispatch = useDispatch();
  return (
    <div>
      <WARecordingSettingModal
        showWAAudioSettingModal={showWAAudioSettingModal}
        waitingArea={props.waitingArea}
        isRecordingEnabled={props.isRecordingEnabled}
        updateOrView={props.updateOrView}
        isAdmin={isAdmin}
        dispatch={dispatch}
      />
    </div>
  );
}
export default WAAudioSettingPage;
